<script setup lang="ts">
import './assets/style.scss'
import { useToast, VToast, VToastTypes, VToastTypesList } from '@/shared/ui'
import { useHelpers, useSseConnection, useTranslate } from '@/shared/lib'
import { watch } from 'vue'
import { useAuth } from '@/entities/Auth'
import { generateUrlToType } from '@/entities/Object'

const auth = useAuth()
const { saveFile } = useHelpers()
const { trs } = useTranslate()
const toast = useToast()
const { toTimeFormat } = useHelpers()

/* Устанавливаем SSE соединение */
const { handler: reportFileHandler } = useSseConnection((res: any) => {
  if (
    res.type &&
    (res.type === 'report_file' || res.type === 'schedule_file') &&
    res.content.link
  ) {
    saveFile(res.content.link)

    toast.add({
      title: trs('itf.download_success'),
      type: VToastTypes.SUCCESS,
      content: trs('itf.download_success_full'),
    })
  }
})

const hasNotificationType = (type: string) => {
  // Если бекенд ещё не отдает notification_types, считаем, что разрешены все типы
  if (!auth.user?.notification_types || !auth.user.notification_types.length) {
    return true
  }

  return auth.user.notification_types.includes(type)
}

const { handler: eventsHandler } = useSseConnection((res: any) => {
  if (
    res.type &&
    ['events', 'tasks'].includes(res.type) &&
    hasNotificationType(res.type) &&
    auth.user?.notify_bubbles &&
    res.status &&
    res.status !== 0
  ) {
    const status = VToastTypesList[res.status] || VToastTypes.SUCCESS
    const title = `<small>${toTimeFormat(res.created_at, 'HH:mm:ss')}</small> ${res.content.object.name}`

    toast.add({
      title,
      type: status,
      content: res.content.message,
      link: generateUrlToType(res.content.object, 'events'),
    })
  }
})

watch(
  () => auth.user?.user_id,
  () => {
    if (auth.user) {
      reportFileHandler(`/user/${auth.user.user_id}/toasts`)
      eventsHandler(`/user/${auth.user.user_id}/events`)
    }
  },
  { immediate: true },
)
</script>

<template>
  <VToast :is-audio="auth.user?.notify_audio" />
</template>
